import { render, staticRenderFns } from "./personalKecelakaanDiri.vue?vue&type=template&id=3dcdc82c&"
import script from "./personalKecelakaanDiri.vue?vue&type=script&lang=ts&"
export * from "./personalKecelakaanDiri.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports